import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from "react-router-dom";
import App from './App';
import "./customcss.css";
import "./ports/language/i18n";
import LangSwitcher from "./components/langSwitcher";


ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);

ReactDOM.render(
  <LangSwitcher />,
  document.getElementById("lang")
);
